function setupToggleContent($container) {
    const $button = $container.querySelector('.toggle-content__button > button'),
        $content = $container.querySelector('.toggle-content__content');

    if (!$button || !$content) {
        return;
    }

    const showLabel = $button.innerHTML,
        hideLabel = $button.getAttribute('data-hide-label');

    $container.classList.add('initialised');

    $button.addEventListener('click', event => {
        if ($content.classList.contains('toggled-on')) {
            $content.classList.remove('toggled-on');
            $content.classList.add('toggled-off');
            //Style to toggle T&C button
            //Inline styles applied as class toggle was not working as expected on all browsers (IE v10)
            //TODO: find an alternative and get the class toggle working on all browsers
            $content.setAttribute('style', 'height: 0px; opacity: 0; display: none');
            $button.innerHTML = showLabel;
        }
        else {
            $content.classList.add('toggled-on');
            $content.classList.remove('toggled-off');
            //Style to toggle T&C button
            //Inline styles applied as class toggle was not working as expected on all browsers (IE v10)
            //TODO: find an alternative and get the class toggle working on all browsers
            $content.setAttribute('style', 'height: 100%; opacity: 1; display: block');
            $button.innerHTML = hideLabel;
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const $candidates = document.querySelectorAll('.toggle-content');

    if ($candidates.length === 0) {
        return;
    }

    for (const $candidate of $candidates) {
        setupToggleContent($candidate);
    }
});